import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { IMarketPrice } from '../../../../interfaces/MarketPrice.interfaces';
import { marketPricePageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { Icon } from '../../../../components/common/icon/Icon';

import { formatPrice } from '../../../../utils/formatter/formatPrice.util';
import { LoginToCheckPrice } from '../components/LoginToCheckPrice';

interface TractorValuePreviewCardProps {
  product: IMarketPrice;
  clickEvent: () => void;
}

export const TractorValuePreviewCard = ({ product, clickEvent }: TractorValuePreviewCardProps) => {
  const navigate = useNavigate();
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  const handleClick = () => {
    clickEvent();
    navigate(`${marketPricePageInfo.detailPage.path}/${product.machine.id}`);
  };

  const getTitle = () => {
    return `${product.brand.name} ${product.machine.model} (${product.machine.engineOutputInPs}마력)`;
  };

  return (
    <Container onClick={handleClick}>
      <TractorImageWrapper>
        <TractorImage src={product.machine.imageMain || product.brand.image} />
      </TractorImageWrapper>

      <PriceInfoSection>
        <TractorTitle>{getTitle()}</TractorTitle>

        <HR />

        <PriceChangedSection>
          {isUserLoggedIn && (
            <>
              <PriceChanedWrapper>
                <Icon name={'AngleFillUp'} size={'Medium'} fill={'#FF3049'} />
                <Price>{`${formatPrice(product.maxPrice)}원`}</Price>
              </PriceChanedWrapper>
              <PriceChanedWrapper>
                <Icon name={'AngleFillDown'} size={'Medium'} fill={'#445EFF'} />
                <Price>{`${formatPrice(product.minPrice)}원`}</Price>
              </PriceChanedWrapper>
            </>
          )}

          {!isUserLoggedIn && <LoginToCheckPrice defaultText={'로그인 후 시세 보기'} isLockIconShow={false} />}
        </PriceChangedSection>
      </PriceInfoSection>
    </Container>
  );
};

const Container = styled.div`
  min-width: 142px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const TractorImageWrapper = styled.div`
  width: 142px;
  height: 129px;
  flex-shrink: 0;
  aspect-ratio: 4/3;
`;

const TractorImage = styled.img`
  width: 100%;
  height: 100%;

  border-radius: var(--radius-large, 16px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
  object-fit: cover;
`;

const PriceInfoSection = styled.div`
  width: 142px;
  padding: 4px 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const TractorTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const PriceChangedSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const PriceChanedWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const Price = styled.span`
  flex: 1 0 0;

  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */
`;

const HR = styled.hr`
  height: 0;
  align-self: stretch;

  stroke-width: 1px;
  stroke: var(--Light-Scheme-Monochrome-grey20, #ececf3);
`;
